export default "__VITE_ASSET__db9e3497__"